<svelte:options accessors={true} />

<script>
    export let title = 'Title'
    export let info = 'Info'
    export let busy = false
</script>

<div class="row">
    {#if typeof busy !== 'undefined' && busy !== false}
        <center>
            {#if busy === true}
                Думаю, подожди ...
            {:else}
                {busy}
            {/if}
        </center>
    {:else}
        <div style="text-align:center;" class="mb-1">
            <h2>{title}</h2>
            {info}&nbsp;
        </div>
        <slot/>
    {/if}
</div>
